import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import Navbar from "scenes/navbar";
import Sidebar from "scenes/sidebar";
import { SyncProvider } from "contexts/SyncContext";

const Layout = () => {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const isUserAuthenticated = user && Object.keys(user).length > 0;

  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return isUserAuthenticated ? (
    <SyncProvider>
      <Box display="flex">
        <Sidebar
          isMobileOpen={isMobileOpen}
          onClose={() => setIsMobileOpen(false)}
        />
        <Box flexGrow={1}>
          <Navbar onOpenMobile={() => setIsMobileOpen(true)} />
          <Outlet />
        </Box>
      </Box>
    </SyncProvider>
  ) : (
    <Navigate to='/login' state={{ from: location }} replace />
  );
};

export default Layout;
